import React from 'react';
import PropTypes from 'prop-types';
import {
  Heading,
  dlsColorModerate,
  dlsColorSuccess,
  dlsColorWarning,
  IconCancelCircle,
  IconSuccess,
  IconWarning,
} from '@americanexpress/dls-react';

export const FxJourneyCompletionPage = ({
  icon,
  status,
  heading,
  subHeading,
  details,
  additionalDetails,
  actions,
  footer,
}) => {
  const renderIcon = () => {
    switch (status) {
      case 'success':
        return <IconSuccess size="lg" theme={dlsColorSuccess} />;
      case 'failed':
        return <IconCancelCircle size="lg" theme={dlsColorWarning} />;
      case 'partial':
        return <IconWarning size="lg" theme={dlsColorModerate} />;
      // the last block in next line will may not be executed as the status fied is mandatory
      /* istanbul ignore next */
      default:
        return null;
    }
  };
  return (
    <div className="flex flex-justify-center">
      <div className="border text-align-center" style={{ width: '720px' }}>
        <div className="pad-responsive-lr stack pad-3-tb">
          <div>
            {icon || renderIcon()}
            <Heading
              level={2}
              headingStyle="heading4"
              className="dls-gray-06"
            >
              {heading}
            </Heading>
          </div>

          {subHeading && (
            <p
              className="body-1 dls-gray-05 margin-2-t"
              id="subHeading"
            >
              {subHeading}
            </p>
          )}

          {details && (
            <div className="margin-2-t" id="details">
              {details}
            </div>
          )}

          {additionalDetails && (
            <div className="margin-4-t" id="additionalDetails">
              {additionalDetails}
            </div>
          )}

          {actions && <div id="actions">{actions}</div>}
        </div>
        {footer && (
          <div className="pad-3-tb margin-4-t pad-responsive-lr dls-gray-01-bg">
            <p>{footer}</p>
          </div>
        )}
      </div>
    </div>
  );
};

FxJourneyCompletionPage.propTypes = {
  icon: PropTypes.node,
  status: PropTypes.oneOf(['success', 'failed', 'partial']).isRequired,
  heading: PropTypes.node.isRequired,
  subHeading: PropTypes.node,
  details: PropTypes.node,
  additionalDetails: PropTypes.node,
  actions: PropTypes.node,
  footer: PropTypes.node,
};

FxJourneyCompletionPage.defaultProps = {
  icon: null,
  subHeading: null,
  details: null,
  additionalDetails: null,
  actions: null,
};
